
/* injects from baggage-loader */

import card2 from "_images/main/card-pg-2.png";
import card4 from "_images/main/card-pg-4.png";
import card5 from "_images/main/card-pg-5.png";
import card6 from "_images/main/card-pg-6.png";
import card7 from "_images/main/card-pg-7.png";
import card8 from "_images/main/card-pg-8.png";
import card9 from "_images/main/card-pg-9.png";
import card10 from "_images/main/card-pg-10.png";


export const cards = [
	{
		card: card2,
		text: "<b>Editorial</b>",
		route: "page-two",
		page: "2"
	},
	{
		card: card4,
		text: "<b>Infográfico Brincar:</b> da era das cavernas à criação de conteúdo digital",
		route: "page-four",
		page: "4"
	},
	{
		card: card5,
		text: "<b>Caçando brincadeiras</b>",
		route: "page-five",
		page: "5"
	},
	{
		card: card6,
		text: "<b>Entrevista:</b> como é ser uma criadora digital",
		route: "page-six",
		page: "6"
	},
	{
		card: card7,
		text: "<b>O que é, o que é:</b> falas da entrevistada",
		route: "page-seven",
		page: "7"
	},
	{
		card: card8,
		text: "<b>Cartas dos leitores - Canudinhos descartáveis:</b> o que fazer com eles?",
		route: "page-eight",
		page: "8"
	},
	{
		card: card9,
		text: "<b>Entre lacunas:</b> o que é a carta do leitor",
		route: "page-nine",
		page: "9"
	},
	{
		card: card10,
		text: "<b>Envie sua carta do leitor!</b>",
		route: "page-ten",
		page: "10"
	}
]





// WEBPACK FOOTER //
// ./src/app/pages/main/main.const.js